import { render, staticRenderFns } from "./sad-builder-element.vue?vue&type=template&id=4c99442a&"
import script from "./sad-builder-element.vue?vue&type=script&lang=js&"
export * from "./sad-builder-element.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports